import angular from 'angular'
import template from './template.html'

angular.module('nominas.cotizacion')
  .component('nominasCotizacionEmpleado', {
    controller: Component,
    template: template,
    bindings: {
      original: '<data',
      modalidad: '<',
      editable: '<',
      onCerrar: '&',
      onEliminar: '&',
    },
  });

function Component() {
  let $ctrl = this;
  // Flags
  $ctrl.cancelando = false;
  // Variables
  $ctrl.data = angular.copy($ctrl.original);
  $ctrl.deducciones = undefined;
  $ctrl.total = undefined;
  // Methods
  $ctrl.recalcular = recalcular;
  $ctrl.aceptar = aceptar;
  $ctrl.eliminar = $ctrl.onEliminar;

  function aceptar() {
    angular.extend($ctrl.original, $ctrl.data);
    $ctrl.onCerrar();
  }

  function recalcular() {
    $ctrl.percepciones = $ctrl.data.Percepciones.reduce(function (prev, next) {
      return prev + next.Importe;
    }, 0);
    $ctrl.deducciones = $ctrl.data.Deducciones.reduce(function (prev, next) {
      return prev + next.Importe;
    }, 0);

    $ctrl.total = $ctrl.percepciones - $ctrl.deducciones;
  }

  recalcular();
}



// WEBPACK FOOTER //
// ./src/nominas/cotizacion/components/empleados/empleado/component.js